import { render, staticRenderFns } from "./ClientProjectsListItem.vue?vue&type=template&id=8c3ea0d6&"
import script from "./ClientProjectsListItem.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports